import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import PackService from "../../../services/PackService";
import withLoader from "../../../components/layouts/WithLoader";
import DataTableProductsPack from "./DataTableProductsPack";

const Pack = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [availablePacks, setAvailablePacks] = useState([]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  useEffect(() => {
    startLoading();
    PackService.allPack(getCurrentUserId(), 1)
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailablePacks(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const onAddPackHandler = () => {
    navigate(`/addPack`);
  };

  const onAddTesteurHandler = () => {
    navigate(`/AddFreePack`);
  };
  const onAddCompositionHandler = () => {
    navigate(`/addPackComposition`);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les packs</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddPackHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Composer un pack</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddCompositionHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les gratuités et les testeurs</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddTesteurHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          </div>

          <section class="content">
            <div class="card">
              <div class="card-header  ">
                <h3 class="card-title">Les pack disponible</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body ">
                {availablePacks && (
                  <DataTableProductsPack listProduits={availablePacks} />
                )}
              </div>
            </div>
          </section>
         
        </div>
     
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(Pack);
